import { fetchData } from 'api/services/mediaPlanning/utils';
import { CAMPAIGN } from './mediaPlanning';

export interface PredictionData {
  mainPrediction?: {
    id?: string;
  };
  partialPrediction?: {
    id?: string;
  };
  budget?: number;
  reach?: number;
  impressions?: number;
}

export interface MetaCampaignDataValue {
  country?: string;
  isGoldenRuleMet?: boolean;
  status?: string;
  message?: string;
  reservedPredictionData?: PredictionData;
  existingPredictionData?: PredictionData;
}

export interface MetaCampaignData {
  status: string;
  value?: MetaCampaignDataValue;
}

export interface MetaCampaignReservationResult {
  status: string;
  data: {
    jobId: string;
    jobStatus: string;
    mediaPlanId: string;
    createdAt: string;
    updatedAt: string;
    results: MetaCampaignData[];
  };
}

export const bookMetaPoll = async (jobId: string | null) => {
  return fetchData<MetaCampaignReservationResult>(
    `/${CAMPAIGN}/check-meta-campaign-reservation-progress?jobId=${jobId}`
  );
};
